import { render, staticRenderFns } from "./live-history.vue?vue&type=template&id=0863a767&scoped=true"
import script from "./live-history.vue?vue&type=script&lang=js"
export * from "./live-history.vue?vue&type=script&lang=js"
import style0 from "./live-history.vue?vue&type=style&index=0&id=0863a767&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0863a767",
  null
  
)

export default component.exports